<template>
    <MainLayout>
        <div class="container">
            <div class="box">
                <b-button 
                    v-if="$hasPermission('meetingInstructions.add')" 
                    class="float-right" 
                    @click="newModel">
                    Nueva instrucción
                </b-button>
                <h2>Meeting Instructions</h2>
                <hr>
                <b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'meeting-instructions-index-list') } ">
                    <div class="row pb-3">
                        <b-form-group class="col-3" label="Nombre">
                            <b-form-input v-model="filters.search" type="text" />
                        </b-form-group>
                        <b-form-group
                            class="col-lg-3"
                            label="Proveedor">
                            <multiselect
                                :options="supplierOptions"
                                v-model="filters.supplier"
                                :multiple="false"
                                :show-labels="false"
                                label="text"
                                track-by="value"/>
                        </b-form-group>
                        <b-form-group
                            class="col-lg-3"
                            label="Default">
                            <b-form-checkbox
                                id="checkbox-1"
                                v-model="filters.default"
                                name="default"
                                value="true">
                                Instrucciones por default
                            </b-form-checkbox>
                        </b-form-group>
                        <b-form-group class="col-2" label=".">
                            <b-button type="submit" variant="primary">Buscar</b-button>
                        </b-form-group>
                    </div>
                </b-form>
                <AjaxTable 
                    permission-show="meetingInstructions.show"
                    id="meeting-instructions-index-list" 
                    :columns="modelColumns" 
                    :filters="filters" 
                    resource="meeting-instructions">
                    <template #cell(zones)="row">
                        <div>
                            <span v-for="(index, value) in row.item.zones" :key="value"
                                class="mr-1">
                                {{ index.name }},
                            </span>
                        </div>
                    </template>
                    <template #cell(meetAndGreet)="row">
                        <div class="text-center">
                            <b-badge variant="success" v-if="row.item.meetAndGreet == true">
                                Meet&Greet
                            </b-badge> 
                        </div>
                    </template>
                    <template #cell(default)="row">
                        <div class="text-center">
                            <b-badge variant="secondary" v-if="row.item.default == true">
                                Default
                            </b-badge> 
                        </div>
                    </template>
                    <template #cell(status)="row">
                        <div class="text-center">
                            <b-badge variant="info" v-if="row.item.status == 'active'">
                                Activo
                            </b-badge> 
                            <b-badge variant="warning" v-if="row.item.status == 'inactive'">
                                Inactivo
                            </b-badge> 
                        </div>
                    </template>
                    <template #cell(actions)="row">
                        <div class="text-center">
                            <b-button  @click="(event) => showPreviewPDF(row.item.id)" 
                                type="button" size="sm" class="mr-1" variant="primary">
                                <md-icon icon="picture_as_pdf" />
                            </b-button>
                            <b-button  @click="(event) => editModel(row.item.id)" 
                                type="button" size="sm" class="mr-1" variant="info">
                                <md-icon icon="edit" />
                            </b-button>
                            <b-button v-if="$hasPermission('meetingInstructions.delete')" 
                            @click="(event) => modelDelete(row.item,row.index,event)" 
                            type="button" size="sm" class="mr-1" variant="danger">
                                <md-icon icon="delete" />
                            </b-button>
                        </div>
                    </template>
                </AjaxTable>
            </div>
        </div>
        <Single :unableEdit.sync="unableEdit" ref="single" :success-callback="successCallback" />
        <b-modal ref="modal-pdf" title="Previsualizar PDF de instrucciones" hide-footer>
            <p class="my-2">Elige la configuración a mostrar</p>
            <b-form @submit="renderPDF">
                <b-form-row>
                    <b-form-group class="col-lg-6" label="Tipo de servicio">
                        <b-form-select size="sm" v-model="pdf.type" :options="serviceTypeOptions" />
                    </b-form-group>
                    <b-form-group class="col-lg-6" label="Idioma">
                        <b-form-select size="sm" v-model="pdf.lang" :options="langOpts" />
                    </b-form-group>
                </b-form-row>

                <b-button
                    class="float-right mt-2"
                    variant="primary"
                    type="submit">
                    Mostrar PDF
                </b-button>
            </b-form>
        </b-modal>
    </MainLayout>
</template>

<script>
    import MainLayout from '../layout/MainLayout.vue'
    import AjaxTable from '../../helpers/AjaxTable.vue'
    import Multiselect from "vue-multiselect"
    import Single from './Single.vue'
    import api from '../../../api.js'

    export default {
        components: {MainLayout, AjaxTable, Single, Multiselect},
        data() {
            return {
                unableEdit: false,
                filters : {
                    search:'',
                    supplier: ''
                },
                pdf: {
                    type: 'arrival',
                    lang: 'es'
                },
                idSelected: null,
                modelColumns: [
                    {key: 'id',             label: 'ID'},
                    {key: 'name',           label: 'Nombre'},
                    {key: 'supplier.name',  label: 'Proveedor'},
                    {key: 'zones',          label: 'Zonas'},
                    {key: 'default',        label: 'Default'},
                    {key: 'meetAndGreet',   label: 'Meet&Greet'},
                    {key: 'status',         label: 'Estatus'},
                    {key: 'actions',        label: 'Acciones'}
                ],
                suppliers: []
            }
        },
        methods: {
            successCallback(){
				this.$root.$emit('bv::refresh::table', 'meeting-instructions-index-list')
			},
			editModel(id) {
				this.$refs['single'].loadModel(id)
			},
            newModel() {
                this.$refs['single'].loadModel(-1)
            },
            modelDelete(item) {              
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						
                        api(this).delete(`/meeting-instructions/${item.id}`).then((response) => {

							if (response.data.error) {
								this.$root.showAlert(response.data.message, {variant: 'warning'})
								close()
								return false
							}

							this.$root.showAlert('Registro Eliminado!', {variant: 'warning'})
							this.$root.$emit('bv::refresh::table', 'meeting-instructions-index-list')
							close()
						}).catch(err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			},
            getSupplierOptions() {
                this.$root.api.get('/suppliers?limit=2000')
                    .then(res => {
                        this.suppliers = res.data.rows;
                    })
                    .catch(this.$root.handleRequestError)
                    .then(() => {
                        this.loading = false;
                    });
            },
            showPreviewPDF(id) {
                // Render PDF
                this.idSelected = id
                this.$refs['modal-pdf'].show();
            },
            renderPDF(event) {
                event.preventDefault()

                const queryString = new URLSearchParams(this.pdf).toString()
                const url = process.env.VUE_APP_API_URL + `/meeting-instructions/${this.idSelected}/pdf?${queryString}`
                window.open(url, '_blank');
            }
        },
        computed: {
            supplierOptions() {
                return this.suppliers.map(rp => ({ value: rp.id, text: rp.name }));
            },
            serviceTypeOptions() {
                return [
                    {value: 'arrival', text: 'LLegada'},
                    {value: 'departure', text:'Salida'}
                ]
            },
            langOpts() {
                return [
                    {value: 'es', text: 'Español'},
                    {value: 'en', text: 'Ingles'}
                ]
            }
        },
        mounted() {
            this.getSupplierOptions()
        },
    }

</script>